// extracted by mini-css-extract-plugin
export default {"header":"Header_header__MY7fH","header__nav":"Header_header__nav__VUwxO","header__menu":"Header_header__menu__Uz+M2"};